import {
  COLUMN_SUBDIVISIONS,
  ROW_SUBDIVISIONS,
} from '@/pages/landingPage/grid/widgetConstraints.ts';

/** Fallback before GridStack reports column count (matches `initOptions.column`). */
export const DEFAULT_LAYOUT_GRID_COLUMNS = 12 * COLUMN_SUBDIVISIONS;

export const defaultGridItemPosition = {
  x: 0,
  y: 0,
};
export const defaultGridItemSize = {
  w: 4 * COLUMN_SUBDIVISIONS,
  h: 12 * ROW_SUBDIVISIONS,
  minW: 4 * COLUMN_SUBDIVISIONS,
  minH: 12 * ROW_SUBDIVISIONS,
};
